import { AudioPlayButton, AudioRendererProps } from "../../radioWidgets/floatingPlayer/audioPlayButton";
import { AodFloatingPlayer } from "../../radioWidgets/floatingPlayer/aodFloatingPlayer";

interface ArticleAudioComponentaProps {
    title: string
    roofTitle: string
    lang: string
    audioUrl: string
    durationSeconds: number
    isMobileWeb: boolean
}

export class ArticleAudioComponenta extends React.Component<ArticleAudioComponentaProps, {}> {
    public static siteScriptName = "ArticleAudioComponenta";

    public render() {
        const { title, roofTitle, durationSeconds, isMobileWeb } = this.props;
        const formatTime = (timeValue: number) => {
            const seconds = Math.floor(timeValue % 60);
            const minutes = Math.floor(timeValue - seconds) / 60;
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        };

        return (
            <div className="ArticleAudioComponenta">
                <div className="main-header">
                    <div className="main-logo" />
                </div>

                <div className="main-container">
                    <div className="details-container">
                        <div className="audio-roof-title">{roofTitle}</div>

                        {isMobileWeb ?
                            <AudioPlayButton
                                {...this.props}
                                durationSeconds={durationSeconds}
                                renderer={(props: AudioRendererProps) => (<RadioNewsflashMobileWeb {...props} />)}
                                floatingPlayerRenderer={(props) => (
                                    <AodFloatingPlayer
                                        {...props}
                                        title={title}
                                        site="radionas"
                                        isMobileWeb={true}
                                        rangeColor="#dee1e76c"
                                        rangeThumbColor="#fff"
                                        rangeProgressColor="#fff"
                                    />)}
                            />
                            :
                            <AudioPlayButton
                                {...this.props}
                                durationSeconds={durationSeconds}
                                renderer={(props: AudioRendererProps) => (<RadioNewsflash {...props} />)}
                                floatingPlayerRenderer={(props) => (
                                    <AodFloatingPlayer
                                        {...props}
                                        title={title}
                                        site="radionas"
                                        rangeColor="#dee1e76c"
                                        rangeThumbColor="#fff"
                                        rangeProgressColor="#fff"
                                    />)}
                            />
                        }
                        
                        <div className="bottom-area">
                            <div className="audio-title">{title}</div>
                            <div className="separator" />
                            <div className="duration-text">{formatTime(durationSeconds)}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function RadioNewsflash({ onTogglePlayPause }: AudioRendererProps) {
    return (
        <div onClick={onTogglePlayPause} className="RadioNewsflash action-button"></div>
    );
}

function RadioNewsflashMobileWeb({ onTogglePlayPause, }: AudioRendererProps) {
    return (
        <div className="RadioNewsflashMobileWebWrapper action-button" onClick={analyticsPushFunc}>
            <div onClick={onTogglePlayPause} className="RadioNewsflashMobileWeb"></div>
        </div>
    );
}

export const analyticsPushFunc = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "GA_Events",
        Category: "Navigation Bar",
        Action: "Click to latest audio news edition",
        Label: "",
    });
}